/**
 * Menu items for DSOK customer-detail section subpages.
 * Visibility rules match the section grid (dsokSectionConfigs.js): typ 1 = all, typ 2 & 7 = devices, colors, products, cart, translations, etc.
 * pathSuffix is appended to /dsok/customer-detail/:customerUrl
 * enabled: false = route not implemented yet, show as disabled with "Coming soon" tooltip.
 */

const TYP_ADMIN = 1;
const TYP_PARTNER = 2;
const TYP_CUSTOMER_USER = 3;
const TYP_SERVICE_PARTNER = 7;

const BASE_LABEL = "dsokCustomerDetail.sections";

function item(id, labelKey, pathSuffix, visibleForTyps, enabled = true) {
  return {
    id,
    labelKey: `${BASE_LABEL}.${labelKey}.title`,
    pathBuilder: (customerUrl) =>
      pathSuffix
        ? `/dsok/customer-detail/${customerUrl}/${pathSuffix}`
        : `/dsok/customer-detail/${customerUrl}`,
    pathSuffix,
    visibleForTyps,
    enabled,
  };
}

export const dsokCustomerDetailMenuItems = [
  item("customer-settings", "customerSettings", "settings", [TYP_ADMIN], true),
  item("app-settings", "appSettings", "application-settings", [TYP_ADMIN], true),
  item("ui-settings", "uiSettings", "ui-settings", [TYP_ADMIN], true),
  item("locations", "locations", "locations", [TYP_ADMIN], true),
  item("devices", "devices", "devices", [TYP_ADMIN, TYP_PARTNER, TYP_CUSTOMER_USER, TYP_SERVICE_PARTNER], true),
  item("colors", "colors", "colors", [TYP_ADMIN, TYP_PARTNER, TYP_SERVICE_PARTNER], true),
  item("products", "products", "products", [TYP_ADMIN, TYP_PARTNER, TYP_SERVICE_PARTNER], true),
  item("cart", "cart", "cart", [TYP_ADMIN, TYP_PARTNER, TYP_SERVICE_PARTNER], true),
  item("integrations", "integrations", "integrations", [TYP_ADMIN], true),
  item("translations", "translations", "translations", [TYP_ADMIN, TYP_PARTNER, TYP_SERVICE_PARTNER], true),
  item("categories", "categories", "categories", [TYP_ADMIN], true),
  item("dynamic-components", "dynamicComponents", "dynamic-components", [TYP_ADMIN], true),
  item("maintenance", "maintenance", "maintenance", [TYP_ADMIN], true),
  item("billing", "billing", "billing", [TYP_ADMIN], true),
];

export function getVisibleMenuItems(customerTyp) {
  return dsokCustomerDetailMenuItems.filter((item) =>
    item.visibleForTyps.includes(customerTyp)
  );
}
